/** Default visible columns in left-to-right display order (schema order unchanged). */
export const APPLICATION_TABLE_DEFAULT_VISIBLE_KEYS = [
  'apartment_building_name',
  'rider_id',
  'stage',
  'tenant_1_name',
  'sf_createdDate',
  'lease_start_date',
  'actions',
];

export const APPLICATION_TABLE_DEFAULT_VISIBLE_KEYS_WITHOUT_BUILDING = [
  'rider_id',
  'stage',
  'tenant_1_name',
  'sf_createdDate',
  'lease_start_date',
  'actions',
];

/** Bump when default columns/order change so persisted prefs reset. */
export const APPLICATION_TABLE_STORAGE_KEY = 'applications-list-v3';
